
import React, { useEffect, useState } from 'react';
import { map, first } from 'rxjs/operators';
import claimService from '../services/claimService';
import { useQuery } from '@tanstack/react-query';
import { firstValueFrom } from 'rxjs';

export const useClaimServiceLineData = (claimId: string | null) => {
    const query = useQuery({
        queryKey: ['claimServiceLines', claimId],
        queryFn: () =>
          firstValueFrom(
            claimService.getClaimServiceLines$(claimId as string).pipe(
              map((response) => response.response.results)
            )
          ),
       });

    return query;
};